import { Injectable } from "@angular/core";
// import * as RecordRTC from "recordrtc";
import * as moment from 'moment';
import { Observable, Subject } from "rxjs";
import { convertWavToMp3, bufferToWave } from './audio.helper';

interface RecordedAudioOutput {
  blob: Blob;
  title: string;
}

@Injectable()
export class AudioRecordingService {
  private stream;
  private recorder;
  private interval;
  private startTime;
  private _recorded = new Subject<RecordedAudioOutput>();
  private _recordingTime = new Subject<string>();
  private _recordingFailed = new Subject<string>();
  // -----new code----
  private chunks: any[] = [];
  private mediaRecorder: any;
  private audioContext: AudioContext = new AudioContext();
  private audioBlobSubject = new Subject<RecordedAudioOutput>();

  audioBlob$ = this.audioBlobSubject.asObservable();

  getRecordedBlob(): Observable<RecordedAudioOutput> {
    return this._recorded.asObservable();
  }

  getRecordedTime(): Observable<string> {
    return this._recordingTime.asObservable();
  }

  recordingFailed(): Observable<string> {
    return this._recordingFailed.asObservable();
  }

  abortRecording() {
    this.stopMedia();
  }

  private toString(value) {
    let val = value;
    if (!value) val = "00";
    if (value < 10) val = "0" + value;
    return val;
  }

  private stopMedia() {
    if (this.recorder) {
      this.recorder = null;
      clearInterval(this.interval);
      this.startTime = null;
      // if (this.stream) {
      //   this.stream.getAudioTracks().forEach(track => track.stop());
      //   this.stream = null;
      // }
    }
  }


  // -------------------------------------
  async startRecordingNew() {
    if (this.audioContext.state === 'suspended') {
      await this.audioContext.resume();
    }

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    this.mediaRecorder = new MediaRecorder(stream);
    this.mediaRecorder.ondataavailable = (event: any) => this.chunks.push(event.data);
    this.mediaRecorder.start();
    this.startTime = moment();
    this.interval = setInterval(() => {
      const currentTime = moment();
      const diffTime = moment.duration(currentTime.diff(this.startTime));
      const time =
        this.toString(diffTime.minutes()) +
        ":" +
        this.toString(diffTime.seconds());
      this._recordingTime.next(time);
    }, 1000);
  }

  async stopRecordingNew() {
    if (this.mediaRecorder) {
      this.mediaRecorder.onstop = async () => {
        const mp3Name = encodeURIComponent(
          "audio_" + new Date().getTime() + ".mp3"
        );
        const audioData = await new Blob(this.chunks).arrayBuffer();
        const audioBuffer = await this.audioContext.decodeAudioData(audioData);
        const wavBlob = await bufferToWave(audioBuffer, audioBuffer.length);
        console.log(wavBlob);
        const mp3Blob = await convertWavToMp3(wavBlob);
        console.log("mp3Blob", mp3Blob);
        this.audioBlobSubject.next({ blob: mp3Blob as Blob, title: mp3Name }); // Typecast wavBlob as Blob
        this.chunks = [];
      };

      this.mediaRecorder.stop();
      clearInterval(this.interval);
      this.startTime = null;
    }
  }

  // ----------------------------------------
}
